import React, { useState } from 'react';
import { Row, Col, Card, DatePicker, Tooltip, Tag } from 'antd';
import moment from 'moment';
import GoBack from '../GoBack';

function SingleSignatureHeader(props) {
  const {
    signatureName,
    pageDetail,
    description,
    selectedDate,
    handleHistoryChange,
    riskType,
    dataSource,
  } = props;

  const [isExpanded, setIsExpanded] = useState(false); // State for toggling description view

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const thirdPartyRisksLinks = {
    'AWS GuardDuty': signatureName =>
      `https://us-east-1.console.aws.amazon.com/guardduty/home?region=us-east-1#/findings?macros=current&fId=${signatureName}`,
  };

  let displayText = '';

  if (dataSource) {
    const riskLink = thirdPartyRisksLinks[dataSource](signatureName);
    displayText = (
      <>
        {dataSource}&nbsp;:&nbsp;
        <a href={riskLink} target="_blank">
          {signatureName}
        </a>
      </>
    );
  } else if (signatureName) {
    displayText = signatureName;
  }

  return (
    <div>
      <Card bordered={false} style={{ fontSize: 14 }}>
        <Row style={{ marginTop: -30 }}>
          <Col span={1}>
            <span style={{ marginLeft: -28 }}>
              <GoBack />
            </span>
          </Col>
          <Col span={16}>
            <p
              style={{
                display: 'inline-block',
                color: '#a9a9a9',
                marginBottom: 3,
                marginLeft: -39,
              }}
            >
              {displayText}
            </p>
          </Col>
          <Col
            span={7}
            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
          >
            {description.includes('(D)') && (
              <div style={{ marginTop: '-5px' }}>
                <Tooltip placement="bottom" title="Please contact support">
                  <Tag color="red">Deactivated</Tag>
                </Tooltip>
              </div>
            )}
            <div style={{ float: 'right', marginTop: '-5px' }}>
              <DatePicker
                style={{ width: '145px' }}
                disabledDate={current => current && current > moment().endOf('day')}
                placeholder="Select Date"
                value={selectedDate ? moment(selectedDate) : moment(new Date())}
                onChange={e => handleHistoryChange(e)}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            span={20}
            style={{
              fontWeight: 'bold',
              fontSize: 17,
              marginBottom: 3,
              marginTop: riskType !== 'thirdPartyRisks' ? '7px' : '0px',
              lineHeight: '25px',
            }}
          >
            {riskType === 'malware'
              ? `${description} found`
              : isExpanded
              ? description
              : description.length > 200
              ? `${description.substring(0, 200)}...`
              : description}
            {description.length > 200 && (
              <span
                onClick={toggleDescription}
                style={{
                  color: '#007BFF',
                  cursor: 'pointer',
                  marginLeft: '5px',
                  fontWeight: 'normal',
                }}
              >
                {isExpanded ? 'Show Less' : 'Show More'}
              </span>
            )}
          </Col>
        </Row>
        <Row>
          <Col
            span={20}
            style={{
              marginTop: riskType !== 'thirdPartyRisks' ? '7px' : '0px',
              color: 'rgba(0,0,0,0.5)',
              fontWeight: 500,
            }}
          >
            {pageDetail}
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default SingleSignatureHeader;
